import permissionsMP4 from './assets/video/permissions.mp4'
import permissionsWebm from './assets/video/permissions.webm'
import testMP3 from './assets/audio/test.mp3'

const assets = {
  img: {},
  audio: {
    testMP3
  },
  video: {
    permissions: {
      permissionsMP4,
      permissionsWebm
    }
  }
}

export default assets
